import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

// Подключаем плагин UTC
dayjs.extend(utc);

// Оборачиваем dayjs для автоматического применения UTC
const dayjsUTC = (...args) => dayjs(...args).utc();

export default dayjsUTC;